import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { ObservacionPersonaDTO } from '../../../../core/models/titulacion/observacionPersona-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class ObservacionPersonaService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getObservacionPersonaService() {
        return this.http.get<BodyListResponse<ObservacionPersonaDTO>>(
            API_URL + '/api/v1/observacionPersona/todos'
        );
    }

    guardarObservacionPersonaService(observacionPersonaDTO: ObservacionPersonaDTO) {
        return this.http.post(API_URL + '/api/v1/observacionPersona', observacionPersonaDTO);
    }

    getObservacionPersonaPorCodigoObservacionPersonaService(codigoObservacionPersona: string) {
        return this.http.get<BodyResponse<ObservacionPersonaDTO>>(
            API_URL + '/api/v1/observacionPersona/' + codigoObservacionPersona
        );
    }
}
